export enum EventCategory {
  NATIONAL_AND_REGIONAL_EVENT = 'NATIONAL_AND_REGIONAL_EVENT',
  CROSS_BORDER_EVENT = 'CROSS_BORDER_EVENT',
  EUROPEAN_LEVEL_EVENT = 'EUROPEAN_LEVEL_EVENT',
  INTERNATIONAL_EVENT = 'INTERNATIONAL_EVENT',
  EU_ENTREPRENEURSHIP_DAY_FOR_STUDENTS = 'EU_ENTREPRENEURSHIP_DAY_FOR_STUDENTS',
}
